import Image from 'next/image';
import React from 'react';
import {defaultPic} from '../../public/assets';
import {getAvatarImage} from '../../context/global/user-context';
import {capitalize} from '../../helpers';

export default function Avatar({src, alt = "Pustack", name = 'S', uid, style = {}, ...props}) {

	return (
		<Image width={100} height={100}
		       src={src === defaultPic || !src ? getAvatarImage(capitalize(name?.replace('Prof. ', '')), uid) : src}
		       alt={alt}
		       style={{objectFit: 'cover', ...style}}
		       {...props}
		/>
	)
}


export function AvatarWithBadge({className, Badge, ...props}) {

	return (
		<div className={"relative " + (className ?? '')}>
			<Avatar className="rounded-[16px] w-full h-full" src={props.src} uid={props.uid} {...props} />
			<div className="absolute transform translate-x-[40%] translate-y-[40%] bottom-0 right-0">
				{Badge}
			</div>
		</div>
	)
}
